<template>
  <button-dialog-container
    :btn-icon="icon"
    :only-icon="true"
    :size="getSize"
    :width-dialog="800"
    :is-valid-disabled="isValid()"
    :no-tool-tip="noToolTip"
    :dialog-viewer.sync="dialog"
    :title-tool-tip="titleToolTip"
    @ok-pushed="rssConfigDone"
    @outside-click="outsideClick"
    @cancel-pushed="cancelRss"
  >
    <v-container class="pa-4">
      <v-row>
        <v-col cols="7">
          <v-row>
            <v-stage
              ref="creationPageWorkspace"
              :config="configKonva"
            />
          </v-row>
          <v-row class="mt-8">
            <v-col>
              <v-text-field
                v-model="urlFeed"
                :rules="[rules.filter.regex]"
                :label="label"
                :placeholder="placeholder"
                hide-details
                clearable
                autofocus
                @update:error="showBtn = !showBtn"
              >
                <template v-slot:append-outer>
                  <v-btn
                    :disabled="showBtn"
                    class="mt-n1"
                    @click="generate()"
                  >
                    {{ $t("creation.tools.dialog.rss.generate") }}
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            dense
            class="mt-2"
          >
            <v-col>
              <v-subheader class="mt-n2">
                {{ $t("creation.tools.dialog.rss.nb-title") }}
              </v-subheader>
              <v-slider
                v-model="countRss"
                step="1"
                min="1"
                max="20"
                thumb-label
                ticks
                @input="changeVisu()"
              >
                <template v-slot:append>
                  <v-combobox
                    v-model="countRss"
                    class="mt-n4"
                    style="marginZero"
                    hide-details
                    single-line
                    :items="countbtnRss"
                    dense
                    @change="clickSize()"
                  />
                </template>
              </v-slider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1">
          <v-divider
            class="ml-4"
            vertical
          />
        </v-col>
        <v-col cols="4">
          <v-row dense>
            <v-subheader>
              {{ $t("creation.tools.dialog.rss.display") }}
            </v-subheader>
            <v-radio-group
              v-model="axeScrolling"
              row
              class="marginZero"
            >
              <v-radio
                class="d-flex pa=0 ma=0"
                :label="$t('creation.tools.dialog.rss.horizontal')"
                :value="true"
                off-icon="mdi-arrow-expand-horizontal"
                on-icon="mdi-arrow-expand-horizontal"
                @change="axeChange()"
              />
              <v-radio
                class="d-flex pa=0 ma=0"
                :label="$t('creation.tools.dialog.rss.vertical')"
                :value="false"
                off-icon="mdi-arrow-expand-vertical"
                on-icon="mdi-arrow-expand-vertical"
                @change="axeChange()"
              />
            </v-radio-group>
          </v-row>
          <v-row dense>
            <v-switch
              v-model="sensScrolling"
              class="marginZero"
              :label="$t('creation.tools.dialog.rss.direction')"
              @change="changeVisu()"
            />
          </v-row>
          <v-row>
            <v-divider class="mb-4 mt-n4" />
          </v-row>
          <v-row dense>
            <v-col
              cols="11"
              class="mt-n2 ml-n2"
            >
              <v-subheader class="marginZero">
                {{ $t("creation.tools.dialog.rss.speed") }}
              </v-subheader>
            </v-col>
            <v-col
              cols="1"
              class="mt-1 ml-2"
            >
              <v-tooltip
                top
                :max-width="160"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dark
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("creation.tools.dialog.rss.text-speed") }}</span>
              </v-tooltip>
            </v-col>
            <v-col>
              <v-slider
                v-model="speed"
                step="10"
                min="10"
                max="200"
                thumb-label
                ticks
                append-icon="mdi-plus-circle-outline"
                prepend-icon="mdi-minus-circle-outline"
                @click:append="velocityMore"
                @click:prepend="velocityLess"
                @input="changeVisu()"
              />
            </v-col>
          </v-row>
          <!-- DIVIDER -->
          <v-row class="mb-4 mt-n4">
            <v-divider />
          </v-row>
          <v-row>
            <v-select
              v-model="align"
              :items="btnAlign"
              item-text="name"
              item-value="value"
              dense
              outlined
              :label="$t('option.align')"
              @change="changeVisu()"
            />
          </v-row>
          <v-row>
            <v-combobox
              v-model="size"
              :items="btnSize"
              dense
              outlined
              :label="$t('option.size')"
              @change="clickSize()"
            />
          </v-row>
          <v-row>
            <v-combobox
              v-model="font"
              :items="btnFont"
              dense
              outlined
              :label="$t('option.font')"
              @change="changeVisu()"
            />
          </v-row>
          <!-- DIVIDER -->
          <v-row class="mb-2 mt-n2">
            <v-divider />
          </v-row>
          <v-row
            dense
            class="mt-n2"
          >
            <v-col>
              <v-row>
                <v-col
                  cols="11"
                  class="mt-n2 ml-n4"
                >
                  <v-subheader>
                    {{ $t("creation.tools.dialog.rss.spacing") }}
                  </v-subheader>
                </v-col>
                <v-col
                  cols="1"
                  class="mt-1 ml-3"
                >
                  <v-tooltip
                    top
                    :max-width="160"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("creation.tools.dialog.rss.text-distance") }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mt-n5">
                  <v-slider
                    v-model="entraxe"
                    step="1"
                    min="1"
                    max="10"
                    thumb-label
                    ticks
                    append-icon="mdi-plus-circle-outline"
                    prepend-icon="mdi-minus-circle-outline"
                    @click:append="entraxeMore"
                    @click:prepend="entraxeLess"
                    @change="changeVisu()"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";

// Libs
import Konva from "konva";

// Tools
const rssParser = require("rss-parser");

export default {
  components: {
    buttonDialogContainer,
  },
  props: {
    currentObject: {
      type: Object,
      default: () => {},
    },
    icon: {
      type: String,
      default: "",
    },
    rules: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    toolName: {
      type: String,
      default: "",
    },
    titleToolTip: {
      type: String,
      default: "",
    },
    noToolTip: {
      type: Boolean,
      default: true,
    },
    getSize: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      dialog: false,
      entraxe: 5,
      anim: new Konva.Animation({}),
      anim2: new Konva.Animation({}),
      showBtn: true,
      countRss: 5,
      size: 48,
      font: "Calibri",
      countbtnRss: [5, 10, 15, 20],
      btnFont: ["Calibri", "Gill Sans", "Arial"],
      btnSize: [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72],
      btnAlign: [
        { value: "left", name: this.$t("align.left") },
        { value: "center", name: this.$t("align.center") },
        { value: "right", name: this.$t("align.right") },
        { value: "justify", name: this.$t("align.justify") },
      ],
      speed: 50,
      sensScrolling: false,
      textList: [],
      textEntered: "",
      axeScrolling: true,
      align: "left",
      baseConfigKonva: {
        x: 0,
        y: 0,
        width: 450,
        height: 350,
        scale: {
          x: this.scale,
          y: this.scale,
        },
      },
      urlFeed: "",
      rssType: "scroll",
    };
  },
  computed: {
    stage() {
      return this.$refs.creationPageWorkspace.getStage();
    },
    configKonva() {
      return this.baseConfigKonva;
    },
    open() {
      return this.$store.state.widget.openEditRss;
    },
  },
  watch: {
    open: function () {
      if (this.open) {
        this.setConfig();
        this.dialog = true;
        this.dblclick = true;
        this.$store.dispatch("editClose").widget;
      }
    },
  },
  mounted() {
    //this.createText("Cliquer hors de la zone pour avoir une demo")
  },
  methods: {
    setConfig() {
      this.urlFeed = this.currentObject.dataScrolling.urlFeed;
      this.text = this.currentObject.dataScrolling.text;
      this.size = this.currentObject.dataScrolling.size;
      this.font = this.currentObject.dataScrolling.font;
      this.axeScrolling = this.currentObject.dataScrolling.axe;
      this.sensScrolling = this.currentObject.dataScrolling.sens;
      this.color = this.currentObject.dataScrolling.color;
      this.speed = this.currentObject.dataScrolling.speed;
      this.align = this.currentObject.dataScrolling.align;
    },
    scrollingHorizontal(textEntered) {
      let start = 0;
      let end = true;
      let absoluteX = this.stage.width();
      const layer = new Konva.Layer();

      const firstText = this.firstText(textEntered);
      const secondText = this.firstText(textEntered);

      const rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: absoluteX,
        height: firstText.size().height,
      });

      firstText.x(absoluteX);
      secondText.x(absoluteX);
      rect.x(absoluteX);
      firstText.y(this.stage.height() - firstText.size().height);
      secondText.y(this.stage.height() - secondText.size().height);
      rect.y(this.stage.height() - rect.size().height);

      const group = new Konva.Group({
        draggable: true,
        dragBoundFunc: function (pos) {
          return {
            x: this.absolutePosition().x,
            y: pos.y,
          };
        },
      });

      group.add(rect, firstText, secondText);
      layer.add(group);
      this.stage.add(layer);

      const velocity = this.speed;
      if (absoluteX * 0.7 < firstText.size().width) {
        start = -(firstText.size().width - absoluteX * 0.3);
      }

      const anim = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        firstText.move({ x: -dist, y: 0 });
        if (firstText.x() <= -firstText.size().width) {
          firstText.x(absoluteX);
          anim.stop();
        }
        if (firstText.x() <= start && end) {
          anim2.start();
          end = false;
        }
      }, layer);

      anim.start();

      const anim2 = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        secondText.move({ x: -dist, y: 0 });
        if (secondText.x() <= -secondText.size().width) {
          secondText.x(absoluteX);
          anim2.stop();
        }
        if (secondText.x() <= start && !end) {
          anim.start();
          end = true;
        }
      }, layer);

      this.anim = anim;
      this.anim2 = anim2;
    },
    scrollingVertical(textEntered) {
      let start = 0;
      let end = true;
      let absoluteY = this.stage.height();
      const layer = new Konva.Layer();

      const firstText = this.firstText(textEntered);
      const secondText = this.firstText(textEntered);

      const rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: firstText.size().width,
        height: this.stage.height(),
      });

      firstText.y(absoluteY);
      secondText.y(absoluteY);
      rect.y(absoluteY);

      const group = new Konva.Group({
        draggable: true,
        dragBoundFunc: function (pos) {
          return {
            x: pos.x,
            y: this.absolutePosition().y,
          };
        },
      });

      if (absoluteY * 0.7 < firstText.size().height) {
        start = -(firstText.size().height - absoluteY * 0.3);
      }
      group.add(rect, firstText, secondText);
      layer.add(group);
      this.stage.add(layer);

      const velocity = this.speed;

      const anim = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        firstText.move({ x: 0, y: -dist });
        if (firstText.y() <= -firstText.size().height + 10) {
          firstText.y(absoluteY);
          anim.stop();
        }
        if (firstText.y() <= start && end) {
          anim2.start();
          end = false;
        }
      }, layer);

      anim.start();

      const anim2 = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        secondText.move({ x: 0, y: -dist });
        if (secondText.y() <= -secondText.size().height) {
          secondText.y(absoluteY);
          anim2.stop();
        }
        if (secondText.y() <= start && !end) {
          anim.start();
          end = true;
        }
      }, layer);

      this.anim = anim;
      this.anim2 = anim2;
    },
    scrollingHorizontalReverse(textEntered) {
      let end = true;
      let absoluteX = this.stage.width();
      const layer = new Konva.Layer();

      const firstText = this.firstText(textEntered);
      const secondText = this.firstText(textEntered);
      const posStart = -(firstText.size().width + 10 * this.countRss);
      const rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: this.stage.width(),
        height: firstText.size().height,
      });

      let start = this.stage.width() - firstText.size().width;

      const group = new Konva.Group({
        draggable: true,
        dragBoundFunc: function (pos) {
          return {
            x: this.absolutePosition().x,
            y: pos.y,
          };
        },
      });

      firstText.x(posStart);
      secondText.x(posStart);
      firstText.y(this.stage.height() - firstText.size().height);
      secondText.y(this.stage.height() - secondText.size().height);
      rect.y(this.stage.height() - rect.size().height);

      group.add(rect, firstText, secondText);
      layer.add(group);
      this.stage.add(layer);

      const velocity = this.speed;
      if (absoluteX * 0.7 < firstText.size().width) {
        start = this.stage.width() * 0.7;
      }
      const anim = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        firstText.move({ x: dist, y: 0 });
        if (firstText.x() >= absoluteX) {
          firstText.x(posStart);
          anim.stop();
        }
        if (firstText.x() >= start && end) {
          anim2.start();
          end = false;
        }
      }, layer);

      anim.start();

      const anim2 = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        secondText.move({ x: dist, y: 0 });
        if (secondText.x() >= absoluteX) {
          secondText.x(posStart);
          anim2.stop();
        }
        if (secondText.x() >= start && !end) {
          anim.start();
          end = true;
        }
      }, layer);

      this.anim = anim;
      this.anim2 = anim2;
    },
    scrollingVerticalReverse(textEntered) {
      let end = true;
      let absoluteY = this.stage.height();
      const layer = new Konva.Layer();

      const firstText = this.firstText(textEntered);
      const secondText = this.firstText(textEntered);

      const rect = new Konva.Rect({
        x: 0,
        y: this.stage.height(),
        width: firstText.size().width,
        height: this.stage.height(),
      });

      let start = absoluteY - firstText.size().height;

      firstText.y(-firstText.size().height);
      secondText.y(-secondText.size().height);
      rect.y(-rect.size().height);

      const group = new Konva.Group({
        draggable: true,
        dragBoundFunc: function (pos) {
          return {
            x: pos.x,
            y: this.absolutePosition().y,
          };
        },
      });

      group.add(rect, firstText, secondText);
      layer.add(group);
      this.stage.add(layer);

      const velocity = this.speed;
      if (absoluteY * 0.7 < firstText.size().height) {
        start = this.stage.height() * 0.7;
      }

      const anim = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        firstText.move({ x: 0, y: dist });
        if (firstText.y() >= absoluteY) {
          firstText.y(-firstText.size().height);
          anim.stop();
        }
        if (firstText.y() >= start && end) {
          anim2.start();
          end = false;
        }
      }, layer);

      anim.start();

      const anim2 = new Konva.Animation(function (frame) {
        const dist = velocity * (frame.timeDiff / 1000);
        secondText.move({ x: 0, y: dist });
        if (secondText.y() >= absoluteY) {
          secondText.y(-secondText.size().height);
          anim2.stop();
        }
        if (secondText.y() >= start && !end) {
          anim.start();
          end = true;
        }
      }, layer);

      this.anim = anim;
      this.anim2 = anim2;
    },
    axeChange() {
      if (!this.axeScrolling) {
        this.entraxe = 5;
      } else {
        this.entraxe = 2;
      }
    },
    async generate() {
      this.textEntered = "";
      this.anim.stop();
      this.anim2.stop();
      this.stage.destroyChildren();
      this.stage.clear();
      this.stage.clearCache();
      await this.transformText();
      if (this.textEntered.length > 0 && this.size > 8 && this.size < 150) {
        if (this.axeScrolling) {
          if (this.sensScrolling) {
            this.scrollingHorizontalReverse(this.textEntered);
          } else {
            this.scrollingHorizontal(this.textEntered);
          }
        } else {
          if (this.sensScrolling) {
            this.scrollingVerticalReverse(this.textEntered);
          } else {
            this.scrollingVertical(this.textEntered);
          }
        }
      }
    },
    async transformText() {
      this.showBtn = !this.showBtn;
      let balise = "  ";
      let feed = this.urlFeed;

      if (this.urlFeed != "" && !(this.anim.isRunning() || this.anim2.isRunning())) {
        this.textEntered = this.urlFeed;
        if (!this.$store.state.config.system.isCreation) {
          let parser = new rssParser();
          feed = await parser.parseURL(this.urlFeed);

          if (!this.axeScrolling) {
            balise = "\r\n";
          }

          for (let j = 1; j < this.entraxe; j++) {
            if (this.axeScrolling) {
              balise = balise.concat("    ");
            } else {
              balise = balise.concat("\r\n");
            }
          }

          for (let i = 0; i < this.countRss; i++) {
            if (i == 0) {
              this.textEntered = feed.items[i].title;
            } else {
              this.textEntered = this.textEntered.concat(balise, feed.items[i].title);
            }
          }
        }

        this.showBtn = false;
      }
    },
    firstText(textEntered) {
      const firstText = new Konva.Text({
        x: 0,
        y: 0,
        text: textEntered,
        fontSize: this.size,
        fontFamily: this.font,
        fill: this.color,
        align: this.align,
      });
      return firstText;
    },
    rssConfigDone() {
      this.anim.stop();
      this.anim2.stop();
      if (this.textEntered.length > 0) {
        const dataScrolling = {
          text: this.urlFeed,
          axe: this.axeScrolling,
          sens: this.sensScrolling,
          speed: this.speed,
          align: this.align,
          size: this.size,
          font: this.font,
          color: this.color,
          urlFeed: this.urlFeed,
          countRss: this.countRss,
          entraxe: this.entraxe,
        };

        if (this.dblclick) {
          this.$emit("editElement", {
            name: "rss",
            content: dataScrolling,
            config: this.currentObject.konvaObjectOption,
          });
          this.dblclick = false;
        } else {
          if (this.toolName) {
            this.$emit("toolSelectedFromDialog", this.toolName);
          }

          this.$emit("rssConfigDone", dataScrolling);
        }
      }
      this.reset();
    },
    velocityLess() {
      this.speed = this.speed - 10 || 0;
      this.changeVisu();
    },
    velocityMore() {
      this.speed = this.speed + 10 || 100;
      this.changeVisu();
    },
    entraxeLess() {
      this.entraxe = this.entraxe - 1 || 0;
      this.changeVisu();
    },
    entraxeMore() {
      this.entraxe = this.entraxe + 1 || 10;
      this.changeVisu();
    },
    clickSize() {
      if (!(this.size > 8 && this.size < 150)) {
        this.size = 30;
      }
      this.changeVisu();
    },
    clickCountTitle() {
      if (!(this.countRss > 1 && this.countRss < 20)) {
        this.countRss = 5;
      }
      this.changeVisu();
    },
    cancelRss() {
      this.urlFeed = "";
      this.outsideClick();
    },
    reset() {
      this.urlFeed = "";
      this.textList = "";
      this.textEntered = "";
      this.stage.clear();
      this.stage.clearCache();
      this.stage.destroyChildren();
    },
    outsideClick() {
      this.reset();
    },
    isValid() {
      if (this.textEntered.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    changeVisu() {
      this.textEntered = "";
      this.showBtn = false;
    },
  },
};
</script>

<style>
.marginZero {
  margin-top: 0px;
  padding: 0px;
}

.separation {
  display: inline-flex;
  flex-direction: center;
  align-content: center;
  align-self: center;
}
</style>
